customError = require '@atlassian/trello-error-ext'
_ = require 'underscore'
assert = require 'lib/assert'

reservedBaseName = "Error"

module.exports = (namespace, names) ->
  baseClass = customError [namespace, reservedBaseName].join('::')

  for name in names
    assert name != reservedBaseName, "#{name} is the reserved base name!"
    assert name !of baseClass, "You can't use #{name} as the name of a custom error"
    baseClass[name] = customError [namespace, name].join('::'), {}, baseClass

  baseClass



// WEBPACK FOOTER //
// ./app/scripts/lib/make-error-enum.coffee